import { render, staticRenderFns } from "./invoiceDetails.vue?vue&type=template&id=33357e22&"
import script from "./invoiceDetails.vue?vue&type=script&lang=js&"
export * from "./invoiceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports